var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"job-edit"}},[_c('card',{staticClass:"pa-4"},[_c('job-form',{attrs:{"btn-label":"Créer l'offre"},on:{"saveForm":_vm.createJob}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }